<template>
  <div class="section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Partners.doorName')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('Payment.contactPerson')">
            <el-input v-model="editDialog.form.contact" no="contact" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="editDialog.form.phone" no="phone" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DoorAddress')">
            <el-input v-model="editDialog.form.address" no="address" />
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
            <cargo-advance-select
              no="city"
              :cache="false"
              filterable
              :default-value="editDialog.form.city"
              :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
              :tag-value="'code'"
              :placeholder="' '"
              :static-options="locationList"
              @parentCallBack="p=>{editDialog.form.city=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ZIP')">
            <el-input v-model="editDialog.form.zipCode" no="zipCode" />
          </el-form-item>
          <cargo-area
            ref="area"
            no="area"
            :country.sync="editDialog.form.country"
            :province.sync="editDialog.form.province"
            :city.sync="editDialog.form.cityNew"
            :district.sync="editDialog.form.county"
            :town.sync="editDialog.form.town"
            :district-label-name="$t('CargoMsg.Cargo_CountyDistrict')"
            :town-label-name="$t('CargoMsg.Cargo_TownStreet')"
            :label-width="'100'"
            :select-width="280"
            :show-town="true"
            style="display: inline-block"
          />
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />
  </div>
</template>

<script>
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getSiteList } from '@/api/partner/site'
import { getLocationList } from '@/api/location'
import cargoArea from '@/components/Cargo/Common/cargoArea.vue'
import $store from '@/store'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'SiteForm',
  components: {
    cargoArea, CargoAiRecognitionDialog,
    cargoAdvanceSelect
  },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      SystemConstants,
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.REGION_PROMPT_KEY.code,
        visible: false
      },
      selectTypeNames: TYPE_NAMES,
      filter: {
        companyUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Partners.doorName'),
          field: 'name',
          width: 200
        }, {
          headerName: this.$t('Payment.contactPerson'),
          field: 'contact',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'phone',
          width: 200
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'address',
          width: 200
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityP'),
          field: 'city',
          width: 200,
          valueFormatter: (params) => {
            let name = ''
            if (this.locationList) {
              const data = this.locationList.find(p => p.code === params.value)
              if (data) {
                name = this.$store.getters.language === 'zh' ? data.chineseName : data.englishName
              }
            }
            return name
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Province'),
          field: 'province',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_city'),
          field: 'cityNewStr',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountyDistrict'),
          field: 'countyStr',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_TownStreet'),
          field: 'townStr',
          width: 200
        }
      ],
      rowData: [],
      locationList: [],
      editDialog: {
        visible: false,
        title: '',
        form: {
          action: 'add',
          uuid: '',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          country: 'CN',
          province: '',
          cityNew: '',
          county: '',
          town: '',
          cityNewStr: '',
          countyStr: '',
          townStr: '',
          village: '',
          zipCode: '',
          companyUuid: ''
        }
      },
      autoIncrementNum: new AutoIncrementNum(),
      selectedNode: null
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    'editDialog.visible': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.clear()
        }
      }
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.filter.companyUuid = row.uuid
        this.toQuery()
      }
    },
    toQuery() {
      const filter = this.filter
      getLocationList({ pageSize: 10000 }).then(res => {
        this.locationList = res.data.list
      })
      if (filter.companyUuid) {
        filter.pageSize = 10000
        filter.branchId = $store.getters.currentOfficeId
        getSiteList(filter).then(res => {
          for (const item of res.data.list) {
            item.seq = this.autoIncrementNum.getNextNum()
          }
          this.rowData = res.data.list
        })
      } else {
        this.rowData = []
      }
      this.deletedSiteKeys = []
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          action: 'add',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          country: 'CN',
          province: '',
          cityNew: '',
          county: '',
          town: '',
          cityNewStr: '',
          countyStr: '',
          townStr: '',
          village: '',
          zipCode: '',
          companyUuid: this.filter.companyUuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...this.selectedRow }
        this.editDialog.form.action = 'edit'
        this.editDialog.form.country = 'CN' // 固定国内
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    clear() {
      if (this.$refs.area && this.editDialog.form.action === 'add') {
        this.$refs.area.clearCity()
        this.$refs.area.clearDistrict()
        this.$refs.area.clearTown()
      }
    },
    saveSub() {
      const form = this.editDialog.form
      if (this.$refs.area) {
        const area = this.$refs.area
        if (area.$refs.city && area.$refs.city.$refs.advanceSelectRef) {
          form.cityNewStr = area.$refs.city.$refs.advanceSelectRef.query
        }
        if (area.$refs.district && area.$refs.district.$refs.advanceSelectRef) {
          form.countyStr = area.$refs.district.$refs.advanceSelectRef.query
        }
        if (area.$refs.town && area.$refs.town.$refs.advanceSelectRef) {
          form.townStr = area.$refs.town.$refs.advanceSelectRef.query
        }
      }
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      this.editDialog.visible = false
    },
    remove() {
      const self = this
      const row = self.selectedRow
      if (!this.selectedRow) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedSiteKeys.push(row.uuid)
        }
      }).catch(() => { })
    },
    getSubmitData() {
      return {
        sites: this.rowData,
        deletedSiteKeys: this.deletedSiteKeys
      }
    }
  }
}
</script>

<style scoped lang="scss">
.grid-view {
  &.section {
    padding: 10px 20px;
  }
}
</style>
